import React from 'react';
import PrimaryButton from '../Custom/PrimaryButton/PrimaryButton';
import { Box, Typography, useMediaQuery } from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';

const WhatsappShareButtonWithText = ({text, ...rest}) => {
   const match400 = useMediaQuery((theme) => theme.breakpoints.down(400));
   
   
   return (
      <Box {...rest}>
         <Typography sx={{mr: 1, fontSize: match400 ? '0.8rem': '1.1rem', color: '#000000', fontWeight: 600}}>{text}</Typography>

         <PrimaryButton
            sx={{
               py: 1.5,
               borderRadius: '5px',
               maxWidth: '20rem',
               fontSize: ['0.7rem', '0.7rem', '0.9rem'],
               textTransform: 'capitalize',
               width: '180px',
               '&:hover': {
                  color: '#000000',
               },
            }}
            IconEnd={WhatsAppIcon}
            component='a'
            href='https://api.whatsapp.com/send?phone=+918169737450&text=Hello%20there%21%20I%20would%20like%20to%20know%20more%20about%20SOLRUF%20or%20would%20like%20to%20purchase%20a%20solar%20product.%20Can%20you%20help%20us%20with%20this%3F'
         >
            WhatsApp
         </PrimaryButton>
      </Box>
   );
};

export default WhatsappShareButtonWithText;
